import React from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import CustomImg from "../../components/common/image/CustomImg";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import CustomLabel from "../../components/common/label/CustomLabel";
import CustomTitle from "../../components/common/title/CustomTitle";
import NormalSmallBtn from "../../components/common/button/NormalSmallBtn";
import NormalBtn from "../../components/common/button/NormalBtn";
import { Link } from "react-router-dom";

const ErrorBlock = styled.div`
`;

const ErrorContentsBlock = styled.div`
    padding-top: 0;
    overflow-x: hidden;
`;

const ErrorImgWrapBlock = styled.div`
    width: 970px;
    min-height: 100vh;
    margin: 0 auto;

    ::after {
        content: "";
        display: block;
        clear: both;
      }
`;

const ErrorTextBlock = styled.div`
    margin-left: 60px;
    margin-top: 38vh;
    float: left;
    line-height: 30px;
    font-size: 24px;
    font-weight: 500;
    word-break: keep-all;
`;

const ErrorMain = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurMenuAction('error'));
        dispatch(setHeaderTransferAction(false));
    })

    return (
        <ErrorBlock>
            <Header />
            <ErrorContentsBlock>
                <ErrorImgWrapBlock>
                    <p style={{ float: 'left' }}>
                        <CustomImg width='562px' height='661px'
                            img_src="/assets/images/common/404-img.png" />
                    </p>
                    <ErrorTextBlock>
                        <CustomTitle marginBottom='20px' fontSize='30px' textColor='#111'
                            title='페이지를 찾을 수 없습니다.' />
                        <Link to='/'>
                            <NormalSmallBtn bgColor='#ffc742' textColor="#111" width="250px" borderRadius='30px'
                                text='메인으로 가기' fontWeight='500' fontSize='22px' height='60px' />
                        </Link>

                    </ErrorTextBlock>
                </ErrorImgWrapBlock>
            </ErrorContentsBlock>
            <Footer />
        </ErrorBlock>
    );
};

export default ErrorMain;